import { h, Component } from 'preact'
import { connect } from 'react-redux'

import Input from '../../../shared/components/Input.jsx'
import Button from '../../../shared/components/Button.jsx'

import { validate } from '../state/actions/verification.js'
import { request } from '../state/actions/email.js'

import '../style/components/VerifyStep.less'

class VerifyStep extends Component {

	constructor(props) {
		super(props)

		this.state = {
			code: '',
			codeValid: false,
			resendAvailable: false,
			timeRemaining: 120 // 2 minutes in seconds
		}

		this.timerInterval = null
	}

	componentDidMount() {
		// Focus the code input
		const codeInput = document.getElementById('code')
		if (codeInput) {
			codeInput.focus()
		}

		// Start countdown timer
		this.timerInterval = setInterval(() => {
			this.setState(prevState => {
				const newTime = prevState.timeRemaining - 1

				if (newTime <= 0) {
					clearInterval(this.timerInterval)
					return {
						timeRemaining: 0,
						resendAvailable: true
					}
				}

				return { timeRemaining: newTime }
			})
		}, 1000)
	}

	componentWillUnmount() {
		if (this.timerInterval) {
			clearInterval(this.timerInterval)
		}
	}

	handleInputCode = e => {
		// Allow only digits and limit to 6 characters
		const value = e.target.value.replace(/\D/g, '').substring(0, 6)

		this.setState({
			code: value,
			codeValid: value.length === 6
		})
	}

	handleSubmit = e => {
		e.preventDefault()

		const { code } = this.state
		const { firstName, lastName, preauthToken } = this.props

		this.props.validate(preauthToken, code, firstName, lastName)
	}

	handleResend = e => {
		e.preventDefault()

		if (!this.state.resendAvailable) {
			return
		}

		const { firstName, lastName, email } = this.props
		this.props.resendCode(firstName, lastName, email)

		// Reset timer
		this.setState({
			resendAvailable: false,
			timeRemaining: 120
		})

		// Restart countdown
		this.timerInterval = setInterval(() => {
			this.setState(prevState => {
				const newTime = prevState.timeRemaining - 1

				if (newTime <= 0) {
					clearInterval(this.timerInterval)
					return {
						timeRemaining: 0,
						resendAvailable: true
					}
				}

				return { timeRemaining: newTime }
			})
		}, 1000)
	}

	formatTime = (seconds) => {
		const mins = Math.floor(seconds / 60)
		const secs = seconds % 60
		return `${mins}:${secs.toString().padStart(2, '0')}`
	}

	render({ email, preauthToken, validating, verificationError }, { code, codeValid, resendAvailable, timeRemaining }) {

		return (
			<section class="VerifyStep">
				<h2>Verify Your Email</h2>
				<p>We've sent a 6-digit verification code to:</p>
				<p class="email">{ email }</p>

				{verificationError && (
					<div class="verification-error">
						<p>{verificationError}</p>
					</div>
				)}

				<form spellcheck="false" onsubmit={ this.handleSubmit }>
					<label for="code">Verification Code</label>

					<Input
						id="code"
						type="text"
						inputmode="numeric"
						pattern="[0-9]{6}"
						maxlength="6"
						errors={{
							valueMissing: 'Please enter the verification code',
							patternMismatch: 'Code must be 6 digits',
						}}
						value={ code }
						placeholder="000000"
						oninput={ this.handleInputCode }
						onchange={ this.handleInputCode }
						required
					/>

					<Button type="submit" disabled={ !codeValid || validating }>
						{validating ? 'Verifying...' : 'Verify Code'}
					</Button>

					<div class="resend-section">
						{resendAvailable ? (
							<>
								<span class="resend-text">Didn't receive it? </span>
								<a href="#" class="resend-link" onclick={ this.handleResend }>
									Resend code
								</a>
							</>
						) : (
							<span class="resend-disabled">
								Resend available in { this.formatTime(timeRemaining) }
							</span>
						)}
					</div>
				</form>
			</section>
		)
	}
}

const mapStateToProps = state => ({
	firstName: state.email.firstName,
	lastName: state.email.lastName,
	email: state.email.address,
	preauthToken: state.email.preauthToken,
	validating: state.verification.validating,
	verificationError: state.verification.error
})

const mapDispatchToProps = dispatch => ({
	validate: (preauthToken, code, firstName, lastName) => dispatch(validate(preauthToken, code, firstName, lastName)),
	resendCode: (firstName, lastName, email) => dispatch(request(firstName, lastName, email))
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(VerifyStep)
